<template>
  <div
    style="
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 24px;
      width: 100%;
      align-items: start;
    "
  >
    <!-- Car Display Card Component -->
    <CarDisplayCard id="car-display-card" :customMsg="customMsg" style="width: 100%">
      <!-- Choice Dialog Component -->
      <ChoiceDialog
        :conflictResolvingChromeOptionCodes="conflictResolvingChromeOptionCodes"
        :filteredSubOptions="filteredSubOptions"
        @toggle-dialog="toggleChoiceDialog"
        v-model="choiceDialog"
      />
      <div class="tw-mt-4 tw-mb-2">
        <!-- Request Order Button -->
        <v-btn
          class="tw-h-9 tw-w-full !tw-bg-[#2E66FF] !tw-text-white hover:!tw-bg-[#F5D101] hover:tw-shadow"
          variant="tonal"
          @click="toggleRequestOrder"
        >
          Request Order
        </v-btn>
        <!-- Request Order Dialog Component -->
        <RequestOrderDialog @toggle-request-order="toggleRequestOrder" v-model="requestOrder" />
      </div>
      <p class="tw-text-xs tw-font-light tw-font-open-sans" style="font-style: italic">
        ** Your Online Order Reservation places your interest to the dealership. It is not a
        purchase or order placement. Completion of this form does not guarantee you a vehicle
        delivery or a specified price.
      </p>
    </CarDisplayCard>
    <div class="tw-rounded" style="width: 100%">
      <div>
        <!-- Primary Option Header -->
        <div
          class="tw-flex tw-justify-between tw-flex-wrap sm:tw-flex-nowrap tw-bg-[#CCCCCC] tw-p-4 tw-font-open-sans"
        >
          <h3 class="tw-font-bold tw-uppercase">
            {{ 'Exterior Color' }}
          </h3>
          <p class="tw-font-extralight tw-flex tw-justify-end">
            {{
              exColors?.find((item) => item.selectionState === 'Selected')?.descriptions[0]
                ?.description
            }}
          </p>
        </div>
        <div class="tw-my-4 tw-px-1">
          <!-- Primary Exterior Color Options -->
          <div
            class="tw-flex tw-justify-start tw-gap-3 tw-items-center tw-flex-wrap tw-w-full tw-rounded tw-mr-2"
          >
            <!-- subOption.chromeOptionCode == selectedChromeCode // subOption.selectionState === 'Selected' -->
            <div v-for="subOption in exColors || []" :key="subOption.chromeOptionCode">
              <div
                @click="
                  !isTogglingOption &&
                  subOption.selectionState !== 'Selected' &&
                  toggleOptionForColor(subOption.chromeOptionCode, subOption)
                "
                :style="`background-color: #${subOption.rgbValue}`"
                class="tw-rounded-full tw-w-9 tw-h-9 tw-border-2 tw-flex tw-flex-col tw-items-center tw-justify-center"
                :class="[
                  subOption.selectionState == 'Selected'
                    ? ' tw-drop-shadow-[0px_0px_3px_rgba(0,0,0,0.75)] tw-border-white'
                    : 'tw-border-slate-200',
                  isTogglingOption
                    ? 'tw-opacity-50 tw-cursor-not-allowed tw-pointer-events-none'
                    : 'tw-cursor-pointer',
                ]"
              >
                <!-- <div style="color: red; z-index: 2000;">
                    {{ selectedChromeCode }}
                  </div> -->
                <div
                  v-if="subOption.msrp > 0"
                  class="tw-bg-white tw-text-xs tw-font-light tw-font-kanit tw-min-w-full tw-text-center tw-border"
                >
                  ${{ subOption.msrp.toLocaleString() }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Other Options -->
      <div v-for="option in optionGroups" :key="option.optionKindId || option.optionKindName">
        <div
          class="tw-flex tw-justify-between tw-flex-wrap sm:tw-flex-nowrap tw-bg-[#CCCCCC] tw-p-4 tw-font-open-sans tw-mt-6"
        >
          <h3 class="tw-font-bold tw-uppercase">
            {{ option.optionKindName == 'Seat Color' ? 'INTERIOR COLOR' : option.optionKindName }}
          </h3>
        </div>
        <div
          v-for="subOption in option.options"
          :key="subOption.chromeOptionCode"
          class="tw-border tw-border-[#d3d3d3] tw-my-[1px] tw-px-3 tw-py-6 tw-text-sm tw-font-earthlight tw-font-open-sans"
        >
          <div class="tw-flex tw-justify-between">
            <div class="tw-flex tw-items-center tw-h-8">
              <!-- Option Checkbox -->
              <v-checkbox
                :key="`${subOption.chromeOptionCode}-${optionsInteractKey}`"
                :model-value="
                  subOption.selectionState === 'Selected' ||
                  subOption.selectionState === 'Included' ||
                  subOption.selectionState === 'Required'
                "
                class="custom-checkbox tw-font-roboto tw-mt-6"
                :ripple="true"
                color="primary"
                :disabled="isTogglingOption || awaitingConfirm"
                @click.prevent.stop="handleSelectionState(subOption)"
              ></v-checkbox>
              <p class="tw-max-w-96">
                {{ subOption.descriptions[0].description }}
              </p>
            </div>
            <p>${{ subOption.msrp.toLocaleString() }}</p>
          </div>
          <div
            v-for="(desc, index) in subOption.descriptions.filter(
              (description) => description.type == 'Extended',
            )"
            :key="index"
            class="tw-mt-2 tw-ml-8 md:tw-mt-1 md:tw-ml-10"
          >
            <div v-if="showDetails[subOption.chromeOptionCode]">
              <p>Includes:</p>
              {{
                desc.description.includes('-inc: ')
                  ? desc.description.replace('-inc: ', '')
                  : desc.description
              }}
            </div>
            <p
              class="tw-font-open-sans tw-text-xs tw-font-extralight"
              @click="toggleDetails(subOption)"
            >
              <v-icon
                :class="{ 'tw-rotate-180': showDetails[subOption.chromeOptionCode] }"
                size="10px"
                class="tw-ml-[2px] tw-transition-all tw-duration-150 !tw-text-gray-600"
                icon="fa fa-angle-down"
              ></v-icon>
              click to {{ showDetails[subOption.chromeOptionCode] ? 'hide' : 'show' }} details
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-block sm:tw-hidden tw-w-full">
      <v-btn
        class="tw-h-9 tw-w-full !tw-bg-[#2E66FF] !tw-text-white hover:!tw-bg-[#F5D101] hover:tw-shadow"
        variant="tonal"
        @click="toggleRequestOrder"
      >
        Request Order
      </v-btn>
    </div>
  </div>
  <!-- Options Dialog Component -->
  <v-dialog v-model="isOpenedOptionsDialog" persistent>
    <OptionsDialog
      :is-applying="isTogglingOption"
      @toggleDialog="closeOptionsDialog"
      @apply="onConfirmOptionChange"
      @cancel="onCancelOptionChange"
    />
  </v-dialog>
</template>

<script setup>
import { ref, watch, onMounted, nextTick, computed } from 'vue';
import CarDisplayCard from '@/components/common/cards/CarDisplayCard.vue';
import RequestOrderDialog from '@/components/common/Dialog/RequestOrderDialog.vue';
import OptionsDialog from '@/components/common/Dialog/OptionsDialog.vue';
import { useVariablesStore } from '@/stores/useVariablesStore';
import { storeToRefs } from 'pinia';
import { useCarsStore } from '@/stores/useCarsStore';
import { useSelectionQuery } from '@/composables/useSelectionQuery';
import ChoiceDialog from '../common/Dialog/ChoiceDialog.vue';
const carStore = useCarsStore();
const { syncQueryToUrl } = useSelectionQuery();
const isOpenedOptionsDialog = ref(false);
const optionsInteractKey = ref(0);
const { getOptionToggle } = carStore;
const {
  modelConfigurationDetails,
  toggleOptionData,
  customMsg,
  carDetails,
  carSelectedDetails,
  customToggleImgLoading,
  filteredCarDetails,
  isTogglingOption,
} = storeToRefs(carStore);
const variablesStore = useVariablesStore();
const { requestOrder } = storeToRefs(variablesStore);

function getExteriorColorOptions(details) {
  return (
    details?.options?.find((item) => item.optionKindName === 'Primary Exterior Color')?.options ||
    []
  );
}

function buildOptionGroups(details) {
  const options = details?.options;
  if (!Array.isArray(options) || !options.length) return [];
  const filtered = options.filter(
    (filteredOption) => filteredOption.optionKindName !== 'Primary Exterior Color',
  );
  const seatIdx = filtered.findIndex((item) => item.optionKindName === 'Seat Color');
  if (seatIdx > 0) {
    const [seat] = filtered.splice(seatIdx, 1);
    filtered.unshift(seat);
  }
  return filtered;
}

const exColors = computed(() => getExteriorColorOptions(modelConfigurationDetails.value));
const optionGroups = computed(() => buildOptionGroups(modelConfigurationDetails.value));

const selectedChromeCode = ref('');
const filteredSubOptions = ref([]);
const conflictResolvingChromeOptionCodes = ref([]);
const selectedValues = ref([]);
const serializedVal = ref('');
const previousSerializedVal = ref('');
const previousSelectionStates = ref({});
const previousCarDetails = ref(null);
const awaitingConfirm = ref(false);
const choiceDialog = ref(false);
const showDetails = ref({});
const toggleChoiceDialog = () => {
  choiceDialog.value = !choiceDialog.value;
};
const toggleDetails = (chromeCode) => {
  showDetails.value[chromeCode.chromeOptionCode] = !showDetails.value[chromeCode.chromeOptionCode];
};
const syncSelectedValues = () => {
  if (!modelConfigurationDetails.value?.options?.length) {
    selectedValues.value = [];
    carSelectedDetails.value = [];
    return;
  }

  carStore.enforceSingleExteriorColor(carStore.selectedColor || selectedChromeCode.value);
  const selectedColorCode =
    carStore.selectedColor ||
    getExteriorColorOptions(modelConfigurationDetails.value).find(
      (option) => option.selectionState === 'Selected',
    )?.chromeOptionCode;

  selectedValues.value = modelConfigurationDetails.value.options.flatMap((selectedVal) =>
    (selectedVal.options || []).filter((val) => {
      const isOn =
        val.selectionState === 'Selected' ||
        val.selectionState === 'Included' ||
        val.selectionState === 'Required';
      if (!isOn) return false;
      if (selectedVal.optionKindName === 'Primary Exterior Color') {
        return val.chromeOptionCode === selectedColorCode;
      }
      return true;
    }),
  );
  carSelectedDetails.value = selectedValues.value;
};

const snapshotUntoggledState = () => {
  previousSerializedVal.value = serializedVal.value;
  previousCarDetails.value = {
    baseMSRP: carDetails.value.baseMSRP,
    optionsMSRP: carDetails.value.optionsMSRP,
    totalMSRP: carDetails.value.totalMSRP,
    subStyleName: carDetails.value.subStyleName,
  };

  const states = {};
  modelConfigurationDetails.value?.options?.forEach((group) => {
    group?.options?.forEach((option) => {
      if (option?.chromeOptionCode) {
        states[option.chromeOptionCode] = option.selectionState;
      }
    });
  });
  previousSelectionStates.value = states;
};

const restoreUntoggledState = () => {
  serializedVal.value = previousSerializedVal.value;

  modelConfigurationDetails.value?.options?.forEach((group) => {
    group?.options?.forEach((option) => {
      const prior = previousSelectionStates.value[option.chromeOptionCode];
      if (prior !== undefined) {
        option.selectionState = prior;
      }
    });
  });

  if (previousCarDetails.value) {
    carStore.$patch({
      carDetails: {
        ...carStore.carDetails,
        ...previousCarDetails.value,
      },
    });
  }

  carStore.$patch({ toggleOptionData: {} });
  syncSelectedValues();
};

const applyToggleResult = (newVal) => {
  if (!newVal) return;

  serializedVal.value = newVal.style?.configurationState?.serializedValue ?? serializedVal.value;
  previousSerializedVal.value = serializedVal.value;

  newVal?.options?.forEach((newOptionGroup) => {
    newOptionGroup?.options?.forEach((newOption) => {
      modelConfigurationDetails.value?.options?.forEach((existingOptionGroup) => {
        existingOptionGroup?.options?.forEach((existingOption) => {
          if (existingOption.chromeOptionCode === newOption.chromeOptionCode) {
            existingOption.selectionState = newOption.selectionState;
          }
        });
      });
    });
  });

  const toggledColorCode =
    newVal?.options
      ?.find((group) => group.optionKindName === 'Primary Exterior Color')
      ?.options?.find((option) => option.selectionState === 'Selected')?.chromeOptionCode ||
    carStore.selectedColor;
  carStore.enforceSingleExteriorColor(toggledColorCode);

  if (newVal?.style) {
    carStore.$patch({
      carDetails: {
        ...carStore.carDetails,
        baseMSRP: newVal.style.baseMsrp,
        optionsMSRP: newVal.configuredOptionsMsrp,
        totalMSRP: newVal.configuredTotalMsrp,
      },
    });
    if (modelConfigurationDetails.value) {
      modelConfigurationDetails.value.configuredOptionsMsrp = newVal.configuredOptionsMsrp;
      modelConfigurationDetails.value.configuredTotalMsrp = newVal.configuredTotalMsrp;
    }
  }

  syncSelectedValues();
};

const closeOptionsDialog = () => {
  isOpenedOptionsDialog.value = false;
};

const resetConfirmFlow = async () => {
  awaitingConfirm.value = false;
  isOpenedOptionsDialog.value = false;
  previousSelectionStates.value = {};
  previousCarDetails.value = null;
  optionsInteractKey.value += 1;
  await nextTick();
};

const onCancelOptionChange = async () => {
  restoreUntoggledState();
  await resetConfirmFlow();
};

const openChoiceDialogFromResult = (newVal) => {
  serializedVal.value = newVal.style.configurationState.serializedValue;
  previousSerializedVal.value = serializedVal.value;
  filteredSubOptions.value = modelConfigurationDetails.value.options.flatMap((option) =>
    option.options.filter((subOption) =>
      newVal?.conflictResolvingChromeOptionCodes.some(
        (item) => item === subOption.chromeOptionCode,
      ),
    ),
  );
  conflictResolvingChromeOptionCodes.value = newVal?.conflictResolvingChromeOptionCodes;
  if (!choiceDialog.value) toggleChoiceDialog();
};

const onConfirmOptionChange = async () => {
  const pending = toggleOptionData.value;
  serializedVal.value =
    pending?.style?.configurationState?.serializedValue ?? serializedVal.value;
  previousSerializedVal.value = serializedVal.value;

  if (pending?.style) {
    carStore.$patch({
      carDetails: {
        ...carStore.carDetails,
        baseMSRP: pending.style.baseMsrp,
        optionsMSRP: pending.configuredOptionsMsrp,
        totalMSRP: pending.configuredTotalMsrp,
      },
    });
    if (modelConfigurationDetails.value) {
      modelConfigurationDetails.value.configuredOptionsMsrp = pending.configuredOptionsMsrp;
      modelConfigurationDetails.value.configuredTotalMsrp = pending.configuredTotalMsrp;
    }
  }

  syncSelectedValues();
  await resetConfirmFlow();
};

const handleSelectionState = async (subOption) => {
  if (isTogglingOption.value || isOpenedOptionsDialog.value || awaitingConfirm.value) return;

  snapshotUntoggledState();
  awaitingConfirm.value = true;

  try {
    const result = await getOptionToggle(serializedVal.value, subOption.chromeOptionCode);

    if (!result?.status) {
      awaitingConfirm.value = false;
      return;
    }

    if (result.status === 'UserChoiceNeeded') {
      awaitingConfirm.value = false;
      openChoiceDialogFromResult(result);
      return;
    }

    if (result.status === 'UserConfirmationNeeded') {
      isOpenedOptionsDialog.value = true;
      return;
    }

    awaitingConfirm.value = false;
    applyToggleResult(result);
  } catch {
    awaitingConfirm.value = false;
  }
};
watch(
  toggleOptionData,
  (newVal) => {
    if (!newVal?.status) return;

    if (awaitingConfirm.value) return;

    if (customToggleImgLoading.value) return;

    if (newVal.status === 'UserChoiceNeeded') {
      openChoiceDialogFromResult(newVal);
      return;
    }

    if (newVal.status === 'UserConfirmationNeeded') {
      awaitingConfirm.value = true;
      isOpenedOptionsDialog.value = true;
      return;
    }

    applyToggleResult(newVal);
  },
  { deep: true },
);
watch(selectedValues, (newVal) => {
  carSelectedDetails.value = newVal;
});
const toggleRequestOrder = () => {
  if (!requestOrder.value) {
    syncSelectedValues();
  }
  requestOrder.value = !requestOrder.value;
  if (requestOrder.value) {
    variablesStore.setCurrentStep('Request');
  } else {
    variablesStore.setCurrentStep('Options');
  }
};

const toggleOptionForColor = async (chromeCode) => {
  if (isTogglingOption.value) return;
  await carStore.applyExteriorColor(chromeCode);
  selectedChromeCode.value = chromeCode;
  serializedVal.value =
    modelConfigurationDetails.value?.style?.configurationState?.serializedValue ??
    serializedVal.value;
  previousSerializedVal.value = serializedVal.value;
  syncSelectedValues();
  syncQueryToUrl();
};

watch(carDetails.styleName, () => {
  selectedChromeCode.value =
    carStore.selectedColor || exColors.value?.[0]?.chromeOptionCode || '';
});

function initDefaultValues() {
  const details = modelConfigurationDetails.value;
  if (!details?.options?.length) {
    filteredCarDetails.value = [];
    return;
  }

  const colors = getExteriorColorOptions(details);
  const configSelected = colors.find((item) => item.selectionState === 'Selected');
  const storeStillSelected = colors.find(
    (item) =>
      item.chromeOptionCode === carStore.selectedColor && item.selectionState === 'Selected',
  );
  const colorToSync =
    storeStillSelected?.chromeOptionCode || configSelected?.chromeOptionCode || colors[0]?.chromeOptionCode;

  carStore.syncExteriorColorPreview(colorToSync);
  selectedChromeCode.value = colorToSync || '';

  serializedVal.value = details?.style?.configurationState?.serializedValue || '';
  previousSerializedVal.value = serializedVal.value;

  filteredCarDetails.value = buildOptionGroups(details);
  syncSelectedValues();
  syncQueryToUrl();
}

watch(
  modelConfigurationDetails,
  (details, prev) => {
    if (!details?.options?.length) return;
    if (details === prev && optionGroups.value.length) return;
    initDefaultValues();
  },
  { immediate: true },
);

onMounted(async () => {
  if (!modelConfigurationDetails.value?.options?.length && carStore.modelVariantId) {
    await carStore.getConfigurationDetails();
    await carStore.getStyleImages();
  }
  initDefaultValues();
});
</script>

<style lang="css" scoped>
.custom-checkbox {
  @apply tw-text-xs;
}
</style>
